import { User } from './user.types';

export enum WorkflowTemplateType {
  USER_VALIDATION = 'USER_VALIDATION',
  DISTRIBUTION_CAMPAIGN = 'DISTRIBUTION_CAMPAIGN',
  AUTOMATIC = 'AUTOMATIC',
}

export enum WorkflowTemplateStepType {
  /** Request a user validation (N users must approve the document) */
  USER_VALIDATION = 'user_validation',

  /** Set a property on a file */
  SET_PROPERTY = 'set_property',

  /** Store the file as a downloadable PDF */
  STORE_AS_PDF = 'store_as_pdf',

  /** Index the file content in our AI */
  INDEX_IN_ASK_AI = 'index_in_ask_ai',

  /** Set the file as readable for anyone on the domain */
  MAKE_DOMAIN_SEARCHABLE = 'make_domain_searchable',

  /** Unlock the file */
  UNLOCK = 'unlock',

  /** Apply the label VERIFIED to the file */
  LABEL_FILE_AS_VERIFIED = 'label_file_as_verified',

  /** Format the file filename */
  FORMAT_FILENAME = 'format_filename',

  /** Ask for acknowledgement of the file for a list of users */
  USER_ACKNOWLEDGEMENT = 'user_acknowledgement',

  /** Generate properties with AI and add them to the file **/
  AUTO_PROPERTIES = 'auto_properties',

  /** Generate tags with AI and add them to the file **/
  AUTO_TAGS = 'auto_tags',

  /** Store the file is the specified directory tree. */
  ORGANIZE_FILE = 'organize_file',
}

export interface WorkflowInstancesResponse {
  workflow_instances: WorkflowInstance[];
}

export interface WorkflowCanContinueResponse {
  can_approve: boolean;
  can_reject: boolean;
  can_acknowledge: boolean;
}

export interface WorkflowTemplateStepSimpleDto {
  id: number;
  name: string;
  index: number;
  type: WorkflowTemplateStepType;
}

export interface WorkflowTemplateSimpleDto {
  id: number;
  name: string;
  type: WorkflowTemplateType;
  is_enabled: boolean;
}

export interface WorkflowUserAction {
  id: number;
  user: User;
  type: string;
  at: string;
}

export enum WorkflowStepState {
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
}

export interface WorkflowStep {
  id: number;
  state: WorkflowStepState;
  template: WorkflowTemplateStepSimpleDto;
  user_actions: WorkflowUserAction[];
  state_modified_at?: string;
}

export enum WorkflowInstanceState {
  WAITING = 'waiting',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
}

export interface WorkflowInstance {
  id: number;
  state: WorkflowInstanceState;
  version_major: number;
  version_minor: number;
  started_by: User;
  template: WorkflowTemplateSimpleDto;
  steps: WorkflowStep[];
  finished_by: User;
  pdf_file_id: string | null;
  file_id: string;
  created_at: string;
  updated_at: string;
  finished_at?: string;
}
